import React from 'react'
import Teaching from '../Teaching/Teaching'

function Teachingpages() {
  return (
    <Teaching/>
  )
}

export default Teachingpages